import { masterSoundVolume } from 'constants/general';

import { noop } from './dom';

interface SoundOptions {
    volume?: number;
    preload?: boolean;
}

export class Sound {
    private audioElement: HTMLAudioElement = null;
    private options: SoundOptions = {};

    constructor(private src: string, options?: SoundOptions) {
        this.options.preload = options?.preload ?? false;
        this.options.volume = options?.volume ?? 1;

        if (this.options.preload) {
            this.preload();
        }
    }

    public preload() {
        if (this.audioElement) return;

        this.audioElement = new Audio(this.src);
        if (this.audioElement.controls) this.audioElement.controls = false;
        if (this.audioElement.disableRemotePlayback) this.audioElement.disableRemotePlayback = true;
        this.audioElement.preload = 'auto';
        this.audioElement.volume = this.options.volume * masterSoundVolume;
        this.audioElement.load();
    }

    public setVolume(vol: number) {
        this.options.volume = vol;

        if (this?.audioElement) {
            this.audioElement.volume = vol * masterSoundVolume;
        }
    }

    public play() {
        // if (document.visibilityState === 'hidden') return;
        if (!this.audioElement) this.preload();

        const p = this.audioElement.play();
        this.audioElement.onended = () => {
            this.audioElement.pause();
            this.audioElement.currentTime = 0;
        };
        if (p) p.then(noop, this._destroy).catch(this._destroy);
    }

    private _destroy() {
        if (this?.audioElement) {
            this.audioElement.src = 'about:blank';
            this.audioElement.load();
            this.audioElement = null;
        }
    }
}
